<template lang="pug">
b-container.mt-5.pb-5
  b-row.align-items-center.justify-content-between
    b-col.align-self-stretch.align-items-center.justify-content-center.d-flex.img-size(cols="12" lg="6")
      //- img(width="100%" src="../../assets/imagesnew/about-image-min.jpg")
    b-col.message(cols="12" lg="6")
      .title History
      p.text
        span.logo-text mktBI
        | &nbsp;was founded in London in 2018 by a former partner in a large cap Private Equity firm. In his experience, while the amount of information available online on most business sectors is plentiful,&nbsp;
        b business executives and non-public market investors often rely on an incomplete and anecdote-heavy fact base.
      p.text This is largely due to the difficulty to gather, maintain and organize information coming from a significant number of constantly-changing sources.
      p.text
        span.logo-text mktBI
        b &nbsp;was created as an innovative digital and algorithm-powered solution to address this issue,
        | &nbsp;and seamlessly provide a complete fact base for business and investment decisions.
</template>

<script>

export default {
  name: 'History'
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color-title: #364149;
$color-subtitle: #767F86;
.img-size {
  min-height: 300px;
  background-position: center;
  background: url("../../assets/imagesnew/about-image-min.jpg");
  background-size: cover;
}
.message {
  color: $color-title;
  font-style: normal;
  font-weight: bold;
  border-top: #36C2CF solid 2px;
  padding: 51px 38px 51px 51px;
  background-color: #F7F8FC;
  .title {
    font-size: 40px;
    line-height: 1.2em;
  }
  .text {
    font-size: 16px;
    color: $color-subtitle;
    font-style: normal;
    font-weight: normal;
    line-height: 1.33em;
    margin-top: 20px;
  }
}

</style>
